<div *ngIf="data" class="print_singleDoc">
  <h1 class="print_singleDoc_title">{{data.title}}</h1>
  <img [src]="data.img" class="print_singleDoc_image" alt="Document">
  <table>
    <thead>
    <tr>
      <th>{{'print.date' | translate}}</th>
      <th>{{'print.id' | translate}}</th>
    </tr>
    </thead>
    <tbody>
    <tr>
      <td>{{data.date}}</td>
      <td>{{data.id}}</td>
    </tr>
    </tbody>
  </table>
</div>
